// Design tokens shared by useCore and every per-screen view builder under
// src/screens/. Centralised here so the "extraire le style" cleanup
// (todo.md, P3) has one place to start from instead of oklch() literals
// scattered across a dozen files. Not a full design system — just the two
// values that were duplicated across the original useNetdoc.js sections.
export const accent = "oklch(0.46 0.075 55)";
export const ink = "oklch(0.4 0.015 60)";
// dc()/dcSoft() used to take a domain and look up a per-domain hue, but the
// lookup table was always empty (see the removed `HUE` object in the old
// useNetdoc.js) — they've always just returned these two constants. Kept as
// functions so call sites (`dc(art.domain)`) don't need to change if a real
// per-domain palette is added later.
export const dc = () => accent;
export const dcSoft = () => "oklch(0.98 0.006 60)";
